import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Images, Settings, LogOut, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "admin-nav-dashboard" },
  { to: "/admin/richieste", label: "Richieste", icon: Users, testid: "admin-nav-leads" },
  { to: "/admin/portfolio", label: "Portfolio", icon: Images, testid: "admin-nav-portfolio" },
  { to: "/admin/impostazioni", label: "Impostazioni", icon: Settings, testid: "admin-nav-settings" },
];

export default function AdminLayout() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => navigate("/admin", { replace: true }))
      .finally(() => setChecking(false));
  }, [navigate]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      navigate("/admin", { replace: true });
    }
  };

  if (checking) {
    return <div className="min-h-screen bg-avorio" data-testid="admin-loading" />;
  }
  if (!user) return null;

  return (
    <div className="min-h-screen bg-avorio flex" data-testid="admin-layout">
      <aside className="w-16 lg:w-60 shrink-0 bg-antracite text-avorio flex flex-col min-h-screen sticky top-0">
        <div className="h-16 lg:h-20 flex items-center justify-center lg:justify-start lg:px-6 border-b border-avorio/10">
          <span className="font-display font-semibold text-xl">V32</span>
          <span className="hidden lg:inline font-mono text-[9px] uppercase tracking-[0.3em] text-pietra ml-2">Admin</span>
        </div>
        <nav className="flex-1 py-6 flex flex-col gap-1 px-2 lg:px-3" aria-label="Navigazione amministrazione">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm transition-colors duration-300 ${
                  isActive ? "bg-avorio/10 text-bronzo" : "text-avorio/60 hover:text-avorio hover:bg-avorio/5"
                }`
              }
            >
              <item.icon className="w-5 h-5 shrink-0" />
              <span className="hidden lg:inline">{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-2 lg:p-3 border-t border-avorio/10 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="admin-view-site"
            className="flex items-center gap-3 px-3 py-3 text-sm text-avorio/60 hover:text-avorio hover:bg-avorio/5 transition-colors duration-300"
          >
            <ExternalLink className="w-5 h-5 shrink-0" />
            <span className="hidden lg:inline">Vedi il sito</span>
          </a>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-3 py-3 text-sm text-avorio/60 hover:text-bronzo hover:bg-avorio/5 transition-colors duration-300"
          >
            <LogOut className="w-5 h-5 shrink-0" />
            <span className="hidden lg:inline">Esci</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-5 sm:p-8 lg:p-12">
        <Outlet />
      </main>
    </div>
  );
}
